export default __webpack_public_path__ + "2f468af73dface9d69cd07a64d8ec07e.png";